export enum CompanyKeys {
  BYDESIGN_HOMES = 'bydesignhomes',
  BROWNS_ESTATE_AGENTS = 'brownsestateagents',
  NEIL_KING = 'neilking',
  ALLEN_RESIDENTAL = 'allenresidential',
  ICEBERG_DIGITAL_ZENDEKS = 'icebergdigitalzendesk',
  GREY_AND_CO = 'greyandco',
  PRICE_ESTATE_AGENTS = 'priceestateagents',
  ICEBERG_DIGITAL = 'icebergdigital',
  KEYS_AND_LEE = 'keysandlee',
  BEERCOCKS = 'beercocks',
  NOEIGHTYSIXESTATEAGENCY = 'noeightysixestateagency',
  NICHOLSONSESTATEAGENTS = 'nicholsonsestateagents',
  ESTATE_AGENCY_X = 'estateagencyx',
  MARK_BURGESS = 'markburgess',
  ROCHFORD_STOKES = 'rochfordstokes',
  RODERICK_THOMAS = 'roderickthomas',
  BRIAN_MCG = 'brianmcg',
  HARRIS_AND_WOOD = 'harrisandwood',
  KINETIC = 'kineticestateagents',
  JACKSONS_PROPERTY = 'jacksonsproperty',
  KEYSTONE_PMC = 'keystonepmc',
  COPE_AND_CO = 'copeandco',
  HARRISON_HOMES = 'harrisonshomes',
  TOWN_AND_CITY_HOMES = 'townandcityhomes',
  PROPERTY_CONNECTIONS = 'propertyconnections',
  LLOYDS_ESTATES = 'lloydsestates',
  THE_PROPERTY_CLOUD = 'thepropertycloud',
  PENDLEHILL_PROPERTIES = 'pendlehillproperties',
  HARBOR_PROPERTY = 'harborproperty',
  CANTELL_AND_CO = 'cantellandco',
}

// Companies that should have live search browser autofill disabled.
// Extend this list to enable the behavior for additional brands.
export const liveSearchAutofillOffCompanyKeys: readonly string[] = [
  CompanyKeys.RODERICK_THOMAS,
];
